import {
  APP_STORE_RATING,
  DownloadFromAppStoreLink,
  HOMEPAGE_APP_DOWNLOAD_URL,
  HOMEPAGE_APP_QR_CODE_URL,
  QrCode,
  Stars
} from '~/components/DownloadAppBlock';

function Rating() {
  return (
    <div className="flex items-center gap-2 text-grey-hide">
      <div aria-hidden>
        <Stars height="16" width="16" />
      </div>
      {APP_STORE_RATING}
    </div>
  );
}

export default function GetTheApp() {
  return (
    <div className="flex flex-col gap-4">
      <p className="font-normal text-grey-hide">
        Join our community, get real-time alerts on the pairs you want most, and
        more with The Sole Supplier app.
      </p>

      <div className="flex gap-6">
        <QrCode
          className="shrink-0 desktop:block"
          qrCode={HOMEPAGE_APP_QR_CODE_URL}
        />

        <div className="flex flex-col justify-center gap-2">
          <p className="hidden font-normal text-grey-hide desktop:block">
            Scan QR to download
          </p>
          <DownloadFromAppStoreLink
            className="max-w-[112px]"
            href={HOMEPAGE_APP_DOWNLOAD_URL}
            pagePosition="Footer"
            placement="footer_app"
          />
          <Rating />
        </div>
      </div>
    </div>
  );
}
